// Predračun za pravna lica — snima polja kao cart attributes i blokira checkout dok PIB nije ispravan.
if (!customElements.get('cart-predracun')) {
  // PIB: 9 cifara, kontrolna cifra po ISO 7064 MOD 11,10
  const isValidPib = (pib) => {
    if (!/^[1-9]\d{8}$/.test(pib)) return false;
    let s = 10;
    for (let i = 0; i < 8; i++) {
      s = (s + Number(pib[i])) % 10;
      if (s === 0) s = 10;
      s = (s * 2) % 11;
    }
    return (11 - s) % 10 === Number(pib[8]);
  };

  customElements.define(
    'cart-predracun',
    class CartPredracun extends HTMLElement {
      connectedCallback() {
        this.check = this.querySelector('.cart-predracun__check');
        this.body = this.querySelector('.cart-predracun__body');
        this.tipInput = this.querySelector('input[type="hidden"][data-attr="Predracun"]');
        this.fields = [...this.querySelectorAll('input[type="text"][data-attr]')];
        this.pending = null;

        // Blok je unutar <cart-items> u draweru, koji svaki „change" tumači kao promenu količine
        // (→ „Došlo je do pogreške prilikom ažuriranja korpe"). Događaji polja ostaju u ovoj komponenti.
        ['change', 'input'].forEach((type) => this.addEventListener(type, (event) => event.stopPropagation()));

        this.tipInput.name = 'attributes[Predracun]';
        this.syncNames();

        this.check.addEventListener('change', () => {
          this.body.hidden = !this.check.checked;
          if (this.check.checked) this.body.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          this.syncNames();
          this.save();
        });

        this.fields.forEach((input) => {
          input.addEventListener('input', () => {
            if (input.dataset.validate) input.value = input.value.replace(/\D/g, '');
            this.showError(input, false);
            this.saveDebounced();
          });
          input.addEventListener('change', () => this.save());
          input.addEventListener('blur', () => {
            if (input.value) this.showError(input, !this.isFieldValid(input));
          });
        });

        const button = document.querySelector(`button[name="checkout"][form="${this.dataset.formId}"]`);
        if (button && !button.dataset.predracunBound) {
          button.dataset.predracunBound = 'true';
          button.addEventListener('click', (event) => {
            const current = document.querySelector(`cart-predracun[data-form-id="${this.dataset.formId}"]`);
            if (current && !current.validateAll()) event.preventDefault();
          });
        }
      }

      // Polja firme se šalju sa formom samo kad je predračun uključen
      syncNames() {
        this.fields.forEach((input) => {
          if (this.check.checked) input.name = `attributes[${input.dataset.attr}]`;
          else input.removeAttribute('name');
        });
      }

      attributes() {
        const on = this.check.checked;
        // Da = podaci potpuni i PIB ispravan; Nepotpun = SMART pravilo blokira checkout
        const status = on ? (this.isComplete() ? 'Da' : 'Nepotpun') : '';
        this.tipInput.value = status;
        const attrs = { Predracun: status };
        this.fields.forEach((input) => {
          attrs[input.dataset.attr] = on ? input.value.trim() : '';
        });
        return attrs;
      }

      saveDebounced() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.save(), typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300);
      }

      // Snimanja idu redom, a telo se sastavlja tek pri slanju — stariji zahtev ne može da pregazi noviji
      save() {
        clearTimeout(this.timer);
        this.pending = (this.pending || Promise.resolve()).then(() =>
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({ attributes: this.attributes() }),
          }).catch(() => {})
        );
        return this.pending;
      }

      isComplete() {
        return this.fields.every((input) => this.isFieldValid(input));
      }

      isFieldValid(input) {
        const value = input.value.trim();
        if (!value) return !('required' in input.dataset);
        if (input.dataset.validate === 'pib') return isValidPib(value);
        if (input.dataset.validate === 'mb') return /^\d{8}$/.test(value);
        return true;
      }

      showError(input, show) {
        const error = input.parentElement.querySelector('.cart-predracun__error');
        if (error) error.hidden = !show;
        input.classList.toggle('cart-predracun__input--error', show);
        if (show) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }

      validateAll() {
        if (!this.check.checked) return true;
        let firstInvalid = null;
        this.fields.forEach((input) => {
          const valid = this.isFieldValid(input);
          this.showError(input, !valid);
          if (!valid && !firstInvalid) firstInvalid = input;
        });
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus({ preventScroll: true });
          return false;
        }
        // forma odmah šalje atribute — status mora biti tačan i ako debounce snimanje još nije prošlo
        this.tipInput.value = 'Da';
        return true;
      }
    }
  );
}
